<template>
    <div class="select-number select-number-small">

        <div class="select-number-body">
            <button type="button" class="select-number-btn select-number-btn-minus"
                    :class="{disabled: quantity === minimumQuantity}" @click="quantity -= quantityStep">
                <svg width="10" height="10">
                    <use xlink:href="#icon-minus"/>
                </svg>
            </button>
            <input type="text" class="select-number-input" :data-min="meterQuantity"
                   v-on:focus="onFocusHandler" v-on:change="onChangeHandler" v-on:blur="onBlurHandler" :value="formattedQuantity" :data-step="meterQuantity"><!--:data-max="meterQuantity * maximumQuantity"-->
            <button type="button" class="select-number-btn select-number-btn-plus"
                    :class="{disabled: quantity === maximumQuantity}" @click="quantity += quantityStep">
                <svg width="10" height="10">
                    <use xlink:href="#icon-plus"/>
                </svg>
            </button>
        </div>

    </div>
</template>

<!--suppress JSUnresolvedVariable -->
<script>
export default {
    name: "ElementOrderPicker",
    props: {
        productId: {
            type: Number,
            default: 0,
        },
        meterQuantity: {
            type: Number,
            default: 0,
        },
        boxQuantity: {
            type: Number,
            default: 0,
        },
        basePrice: {
            type: Number,
            default: 0,
        },
        minimumQuantity: {
            type: Number,
            default: 1,
        },
        maximumQuantity: {
            type: Number,
            default: Infinity,
        },
        currentQuantity: {
            type: Number,
            default: 1,
        },
        quantityStep: {
            type: Number,
            default: 1,
        },

        minimalOrderPrice: {
            type: Number,
            default: 20000,
        },
        pieceGood: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            quantity: this.currentQuantity,
            mode: 'box', // ['meter', 'box']

            ajaxTimeout: 0,
        }
    },
    computed: {
        price() {
            /**
             * Цена уже умножена на boxQuantity
             */
            return this.basePrice * this.quantity;
        },
        measure() {
            if(this.pieceGood) {
                return ' шт.';
            } else {
                return ' м²';
            }
        },
        formattedQuantity() {
            if (this.mode === 'meter') {
                if( this.meterQuantity === 0 ) {
                    return `${(1 * this.quantity)} ` + this.measure;
                } else {
                    return `${(this.meterQuantity * this.quantity).toFixed(2)} ` + this.measure;
                }
            } else {
                return `${this.quantity} ${this.measure}`;
            }
        }
    },
    watch: {
        quantity(quantity) {
            if (quantity < this.minimumQuantity || isNaN(quantity)) {
                this.quantity = this.minimumQuantity;
            }

            // if (quantity > this.maximumQuantity) {
            //     this.quantity = this.maximumQuantity;
            // }

            clearTimeout(this.ajaxTimeout);
            this.ajaxTimeout = setTimeout(this.updateOthers, 500);
        }
    },
    methods: {
        updateOthers() {
            let formData = new FormData(),
                params = {
                    sessid: BX.bitrix_sessid(),
                    action: 'setBasketQuantity',
                    id: this.productId,
                    quantity: this.quantity,

                    price: Math.round(this.basePrice * this.boxQuantity),

                    meterQuantity: this.meterQuantity,
                    boxQuantity: this.boxQuantity,
                };


            for (let key in params) {
                formData.append(key, params[key]);
            }

            axios.post('/ajax/', formData).then(response => {
                if (response.data.success) {
                    $('.head-cart-count').text(response.data.basket.quantity);
                    $('.head-cart-sum, .js-price-total').text(response.data.basket.summaryFormatted);

                    $(`.js-quantity-total-${this.productId}`).text((this.meterQuantity * this.quantity).toFixed(2));

                    let formattedPrice = Intl.NumberFormat('ru-RU').format(this.price);
                    $(`.js-price-total-${this.productId}`).html(`${formattedPrice}&nbsp;руб.`);

                    $('.js-total-quantity').text(response.data.basket.quantity);

                    let n = response.data.basket.quantity;
                    let plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);

                    let quantityPlurals = ['упаковка', 'упаковки', 'упаковок'];

                    $('.js-total-quantity-plural').text(quantityPlurals[plural]);

                    $('.js-total-meter-quantity').text(response.data.basket.meterQuantity);

                    let difference =  this.minimalOrderPrice - response.data.basket.summary;
                    let formattedDifference = Intl.NumberFormat('ru-RU').format(difference);
                    $('.js-dirrerence').html(`${formattedDifference}&nbsp;руб.`);
                } else {
                    let error = response.data.errors[0] ? response.data.errors[0].message : '';

                    error && console.error(error);
                }
            });

        },
				onFocusHandler(e) {
						e.target.value = this.quantity;
				},
				onBlurHandler(e) {
						e.target.value = this.formattedQuantity;
				},
				onChangeHandler(e) {
						this.quantity = parseInt(e.target.value);
				}
    }
}
</script>

<style scoped>

</style>